import React, { useCallback } from 'react';
import clsx from 'clsx';
import { TypedMemo } from '../../../common/types';
import { SocialLoginVariant, SocialPlatform } from '../types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole Promote pillar; each part uses its own slice of it */
import styles from './PromoteChannels.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface InstagramLoginActionProps {
  label: string;
  disabled?: boolean;
  /** `inherit` takes the text colour of its parent, for the result banner. */
  tone?: 'brand' | 'inherit';
  /** Starts the connect flow. This action asks for the Instagram login of Instagram. */
  onConnect: (platform: SocialPlatform, loginVariant?: SocialLoginVariant) => void;
}

/**
 * The second way to connect Instagram: the sign-in of Instagram itself, for an account that is
 * not linked to a Facebook Page. A quiet text action, below the main Connect button. The caller
 * shows it only when the channel has `alternativeLogin === 'instagram'`.
 */
const InstagramLoginActionComponent: React.FC<InstagramLoginActionProps> = ({
  label,
  disabled = false,
  tone = 'brand',
  onConnect,
}) => {
  const signIn = useCallback(() => onConnect('instagram', 'instagram'), [onConnect]);

  return (
    <button
      type="button"
      className={clsx(styles.textAction, tone === 'inherit' && styles.textActionInherit)}
      disabled={disabled}
      onClick={signIn}
      data-testid="instagram-login-action"
    >
      {label}
    </button>
  );
};

export const InstagramLoginAction = TypedMemo(InstagramLoginActionComponent);
